const {Component} = require("react");
const noUiSlider = require("nouislider");
const PropTypes = require("prop-types");
const {numberFormat} = require("app/util/formaters");
const Link = require("app/components/mixins/Link");
const Trans = require('app/components/trans/Trans');

class PriceFilter extends Component {

	static get propTypes() {
		return {
			title: PropTypes.string,
			min: PropTypes.number,
			max: PropTypes.number,
			currency: PropTypes.string,
			currencyBefore: PropTypes.bool
		};
	}

	static get defaultProps() {
		return {
			title: translate("Pris"),
			min: 0,
			max: 1000,
			currency: "",
			currencyBefore: false
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			min: props.min,
			max: props.max,
			hasSelection: false
		};
	}

	componentDidMount() {
		noUiSlider.create(this.sliderElement, {
			connect: true,
			start: [
				this.props.min,
				this.props.max
			],
			range: {
				min: [this.props.min],
				max: [this.props.max]
			}
		});

		this.sliderElement.noUiSlider.on("update", values => {
			this.onUpdate({
				min: Math.round(parseFloat(values[0])),
				max: Math.round(parseFloat(values[1]))
			});
		});

		this.sliderElement.noUiSlider.on("change", values => {
			this.onChange({
				min: Math.round(parseFloat(values[0])),
				max: Math.round(parseFloat(values[1]))
			});
		});
	}

	get className() {
		let classList = ["price-filter"];

		if (this.state.hasSelection) {
			classList.push("has-selection");
		}

		return classList.join(" ");
	}

	formatCurrency(value) {
		return this.props.currencyBefore ?
			this.props.currency + numberFormat(value) :
			numberFormat(value) + this.props.currency;
	}

	get minText() {
		return this.formatCurrency(this.state.min);
	}

	get maxText() {
		return this.formatCurrency(this.state.max);
	}

	normalizeState(state) {
		state.hasSelection = (state.min !== this.props.min) || (state.max !== this.props.max);
		return state;
	}

	onUpdate(state) {
		this.setState(this.normalizeState(state));
	}

	onChange(state) {
		this.setState(this.normalizeState(state));
	}

	_onReset = () => {
		//e.preventDefault();

		this.sliderElement.noUiSlider.set([
			this.props.min,
			this.props.max
		]);

		this.onChange({
			min: this.props.min,
			max: this.props.max,
		});
	};

	renderReset() {
		if (this.state.hasSelection) {
			return (
				<Link href="#" className="reset" onClick={this._onReset}><Trans>Nulstil</Trans></Link>
			);
		}
	}

	render() {
		return (
			<div className={this.className}>
				<div className="header">
					<div className="title">{this.props.title}</div>
					{this.renderReset()}
				</div>
				<div ref={el => this.sliderElement = el}></div>
				<div className="labels">
					<div className="min">{this.minText}</div>
					<div className="max">{this.maxText}</div>
				</div>
			</div>
		);
	}

}

module.exports = PriceFilter;
